export default __webpack_public_path__ + "static/media/environT.24d60106.svg";